export const filterNestedOptions = (
    input: string,
    option?: { children?: React.ReactNode }
  ): boolean => {
    if (!option?.children) return false
  
    let labelText = ''
  
    if (typeof option.children === 'string' || typeof option.children === 'number') {
      labelText = option.children.toString()
    } else if (Array.isArray(option.children)) {
      labelText = option.children
        .map(child => (typeof child === 'string' || typeof child === 'number' ? child : ''))
        .join(' ')
    } else if (typeof option.children === 'object' && option.children !== null && 'props' in option.children) {
      const props = (option.children as any).props
      labelText = typeof props?.children === 'string' ? props.children : ''
    }
  
    return labelText.toLowerCase().includes(input.toLowerCase())
  }
  